<template>
  <div class="wallet-list h-full">
    <BaseContainer>
      <template slot="content">
        <div class="admin-list-wrap h-full" v-loading="loading">
          <div class="top-box">
            <div>
              <div class="title">
                我的收入
                <el-tooltip content="我的收入包括活动获得金额、微信充值的转移金额" placement="top" effect="light">
                  <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                </el-tooltip>
              </div>
              <div class="amount leading-22">
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">当前可提现余额(元)</div>
                  <div class="font-semibold text-large-x">{{ transformMoney(customerCapital.reward) }}</div>
                </div>
                <div class="line"></div>
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">
                    累积获得金额(元)
                    <el-tooltip content="累积获得金额包括活动获得金额、微信充值的转移金额" placement="top" effect="light">
                      <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                    </el-tooltip>
                  </div>
                  <div class="leading-22 font-semibold text-large-x">{{ transformMoney(customerCapital.sumReward) }}</div>
                </div>
                <div class="line"></div>
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">累计已提现金额(元)</div>
                  <div class="leading-22 font-semibold text-large-x">{{ transformMoney(customerCapital.cashOut) }}</div>
                </div>
              </div>
              <el-button type="success" icon="icon-duanxinfasong" plain size="mini" class="mt-2" @click="cashOutToWeChat">提现到微信</el-button>
            </div>

            <div>
              <div class="title">我的充值</div>
              <div class="amount leading-22">
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">
                    当前账户余额(元)
                    <el-tooltip content="账户余额：指的是微信充值金额-活动已花费金额" placement="top" effect="light">
                      <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                    </el-tooltip>
                  </div>
                  <div class="font-semibold text-large-x">{{ transformMoney(customerCapital.balance) }}</div>
                </div>
                <div class="line"></div>
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">
                    冻结金额(元)
                    <el-tooltip placement="top" effect="light">
                      <div slot="content" class="leading-22 text-theme-black-850">
                        <div>冻结金额指您在平台内某项业务或交易所预支付的资金，业务或交易完成后按实际情况进行扣除。</div>
                        <div>如何解冻？</div>
                        <div>有奖问卷关闭回收后，未结算费用将原路退还。</div>
                      </div>
                      <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                    </el-tooltip>
                  </div>
                  <div class="leading-22 font-semibold text-large-x">{{ transformMoney(customerCapital.freezes) }}</div>
                </div>
                <div class="line"></div>
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">累计充值金额(元)</div>
                  <div class="leading-22 font-semibold text-large-x">{{ transformMoney(customerCapital.sumBal) }}</div>
                </div>
              </div>
              <el-button type="success" icon="icon-duanxinfasong" plain size="mini" class="mt-2" @click="wxRecharge">微信充值</el-button>
              <el-button type="success" plain size="mini" class="mt-2" :disabled="customerCapital.balance === 0" @click="fundTransfer">资金转移</el-button>
            </div>
          </div>
          <div class="top-box mt-4">
            <div>
              <div class="title">我的支出<span>(暂不支持线上开票，如需开票请联系客服)</span></div>
              <div class="amount leading-22">
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">
                    平台代发金额(元)
                    <el-tooltip content="平台代发、任务结算等" placement="top" effect="light">
                      <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                    </el-tooltip>
                  </div>
                  <div class="font-semibold text-large-x">{{ transformMoney(customerCapital.sumUse) }}</div>
                </div>
                <div class="line"></div>
                <div class="text-theme-black-850">
                  <div class="mb-1 text-medium text-theme-black-650">
                    累计其他消费金额(元)
                    <el-tooltip content="活动发布花费短信费用等" placement="top" effect="light">
                      <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer"></i>
                    </el-tooltip>
                  </div>
                  <div class="leading-22 font-semibold text-large-x">{{ transformMoney(customerCapital.sumTranReard) }}</div>
                </div>
                <div></div>
              </div>
            </div>
            <p></p>
          </div>
          <div class="list-box">
            <div class="title">交易明细</div>
            <div class="search-box">
              <el-row :gutter="16">
                <el-col :span="3"><el-input v-model="tradeNo" placeholder="交易流水号"></el-input></el-col>
                <el-col :span="6">
                  <el-date-picker
                    v-model="createTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-col>
                <el-col :span="3">
                  <el-select v-model="service" placeholder="请选择渠道" @change="getSearchType">
                    <el-option
                      v-for="item in channelOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="3">
                  <el-select v-model="type" placeholder="请选择类型">
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="3">
                  <el-button type="primary" @click="searchList">查询</el-button>
                  <el-button type="primary" plain @click="reset">重置</el-button>
                </el-col>
              </el-row>
            </div>

            <div class="tableData">
              <data-table
                :data="data"
                :columns="column"
                :page="page"
                :showPage="true"
                :loading="tableLoading"
                @size-change="sizeChange"
                @pagination-current-change="currentChange"
                height="calc(100% - 40px)"
              >
                <!-- 交易时间 -->
                <template #createdAt="{ row }">
                  <div>{{ timestampToTime(row.createdAt) }}</div>
                </template>
                <!-- 交易渠道 -->
                <template #service="{ row }">
                  <div>{{ transactionChannelList[row.service - 1] }}</div>
                </template>
                <!-- 交易类型 -->
                <template #type="{ row }">
                  <div>{{ transactionTypeList[row.type - 1] }}</div>
                </template>
                <!-- 金额变化 -->
                <template #amount="{ row }">
                  <div v-if="row.type > 16">{{ transformMoney(row.amount) }}</div>
                  <div v-else>{{ row | amountSymbol }}{{ transformMoney(Math.abs(row.amount)) }}</div>
                </template>
                <!-- 交易状态 -->
                <template #status="{ row }">
                  <div>{{ transactionStatusList[row.status] }}</div>
                </template>
                <!-- 付款方式 -->
                <template #payType="{ row }">
                  <div>{{ transactionPayTypeList[row.payType] }}</div>
                </template>
              </data-table>
            </div>
          </div>
        </div>
      </template>
    </BaseContainer>
    <!-- 个人信息 弹窗 -->
    <PersonalMsg :personalMsgShow="personalMsgShow" @onCloseDialog="personalMsgShow = false" />
    <!-- 充值数值弹窗 -->
    <el-dialog
      title="账户充值"
      :visible.sync="amountDialogVisible"
      width="520px"
      :before-close="handleAmountClose">
      <el-form :model="amountForm" :rules="amountRule" ref="amountForm">
        <el-form-item prop="amount">
          <el-input v-model="amountForm.amount" placeholder="请输入充值金额，最低一元"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="normal-button" @click="submitRecharge">充 值</el-button>
      </span>
    </el-dialog>
    <!-- 二维码弹窗(充值) -->
    <el-dialog
      title="请微信扫码充值"
      :visible.sync="codeDialogVisible"
      width="30%"
      :before-close="handleCodeClose">
      <vue-qr
        class="m-auto"
        :text="codeUrl"
        :margin="0"
        :size="200"
        style="display: block;"
      />
      <div class="text-medium-x text-theme-black-850 text-center mt-4">充值仅限本人充值，暂不支持他人代充值</div>
    </el-dialog>
    <!-- 二维码弹窗(提现) -->
    <el-dialog
      title="扫码完成提现"
      :visible.sync="officialCodeDialogVisible"
      width="30%"
      :before-close="handleOfficialCodeClose">
      <div class="text-medium-x text-theme-black-850 leading-22">
        <img :src="codeSrc" alt="" class="officialCode">
        <p class="mt-4 mb-2 font-bold">说明</p>
        <p>1. 打开微信，扫码关注“调研工厂”公众号</p>
        <p>2. 点击公众号菜单“我要提现”</p>
        <p>3. 您的提现将以红包的方式进行发放，请及时领取</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import { mapGetters } from 'vuex'
import DataTable from '@/components/base/DataTable'
import BaseContainer from '@/layout/base/BaseContainer'
import { column, transactionChannelList, transactionTypeList, transactionStatusList, transactionPayTypeList } from './options'
import { getCustomerCaptial, getTransactionList, tradeRecordChanelApi, tradeRecordTypeApi, getQrCodeData, userInnerFundTransfer, withdrawalTest, getWeChatCashOutInfo, weChatCashOut } from '@/api/company/money'
import { getSurveyDomain } from '@/assets/js/config/env'

export default {
  name: 'WalletList',
  components: { BaseContainer, DataTable, VueQr },
  data() {
    return {
      column,
      transactionChannelList,
      transactionTypeList,
      transactionStatusList,
      transactionPayTypeList,
      codeSrc: process.env.VUE_APP_OFFICIAL_ACCOUNT_QR_CODE,
      loading: true,
      tradeNo: '',
      createTime: [],
      service: '',
      type: '',
      name: '',
      mobile: '',
      channelOptions: [],
      typeOptions: [],
      tableLoading: true,
      data:[],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      customerCapital: {
        cashOut: 0,
        sumReward: 0,
        reward: 0,
        freezes: 0,
        sumBal: 0,
        balance: 0,
        sumUse: 0,
        sumTranReard: 0
      },
      YinLianCustomerCapital: {},
      personalMsgShow: false, // 控制个人信息弹窗的显隐
      amountDialogVisible: false, // 输入数值弹窗的显隐
      codeDialogVisible: false, // 支付二维码弹窗的显隐
      officialCodeDialogVisible: false, // 绑定小程序弹窗的显隐
      amountForm: {
        amount: null
      },
      amountRule: {
        amount: [
          { required: true, message: '请输入充值金额，最低一元', trigger: 'blur' },
          { validator:(rule,value,callback) => {
              const reg = /^[0-9]{1,8}([.][0-9]{1,2})?$/
              if (!reg.test(value) || value < 1) {
                callback(new Error('最多输入小数点后两位, 最低一元'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ]
      },
      codeUrl: '',
      timer: null,
      withdrawalData: {}, // 提现检测信息
      cashOutData: {}, // 当日提现信息
    }
  },
  watch: {
    codeDialogVisible(val) {
      if(val) {
        this.timer = setInterval(() => {this.getMoneyData()}, 1000)
      } else {
        clearInterval(this.timer)
      }
    }
  },
  filters: {
    amountSymbol(row) {
      if(row.reward || (row.type === 6 && row.amount > 0)) {
        return '±'
      } else if((row.type <= 5 || row.type >= 9) && row.amount > 0) {
        return '+'
      } else if (row.type === 7 || row.type === 8) {
        return ''
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters(['customerUserInfo']) // weixinBinding: 是否绑定微信；
  },
  methods: {
    // 绑定小程序弹窗的关闭事件
    handleOfficialCodeClose() {
      this.officialCodeDialogVisible = false
    },
    // 提现到微信
    cashOutToWeChat() {
      const openId = this.withdrawalData.openId
      const unionId = this.withdrawalData.unionId
      const count = this.cashOutData.count // 已提现次数
      const total = this.cashOutData.total // 已提现金额
      const cash = this.customerCapital.reward // 当前账户中可提现余额
      const reCash = 50000 - total // 今日账户剩余提现额度
      if (openId) {
        if (cash < 30) {
          this.$alert('由于微信提现限制，金额需大于 0.3 元方可提现哦，微信搜索“调研工厂”小程序，可答题领取更多现金红包。', '提现', {
            confirmButtonText: '我知道了'
          })
        } else if (total >= 50000) {
          this.$alert('您今天的提现金额已超过微信提现限制（每用户每天 500.00元），无法提现，请明天再来操作哦~', '提现', {
            confirmButtonText: '我知道了'
          })
        } else if (count >= 10) {
          this.$alert('您今天的提现此时已超过微信提现限制（每用户每天 10 次），无法提现，请明天再来操作哦~', '提现', {
            confirmButtonText: '我知道了'
          })
        } else if(cash + total > 50000) {
          this.$confirm(`<div>
              <div>微信提现限制：每用户每天 1000.00 元</div>
              <div>今天已提现：${this.transformMoney(total)} 元</div>
              <div>本次可提现：${this.transformMoney(50000 - total)} 元</div>
              <div>是否提现？</div>
            </div>`,'提现', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '提现',
            cancelButtonText: '暂不提现'
          }).then(() => {
            this.getMoneyFun(reCash)
          })
        } else {
          this.$confirm(`<div>
              <div>本次提现：${this.transformMoney(cash)} 元</div>
              <div>是否提现？</div>
            </div>`, '提现', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '提现',
            cancelButtonText: '暂不提现'
          }).then(() => {
            this.getMoneyFun(cash)
          })
        }
      } else if (unionId) {
        this.officialCodeDialogVisible = true
      } else {
        this.personalMsgShow = true
      }
    },
    // 提现最后调用的方法
    getMoneyFun(money) {
      weChatCashOut(money).then(res => {
        if (res.payOuts.length === 0) return
        if (res.payOuts[0].id === 0) {
          this.$message.error(res.payOuts[0].errMsg)
          return
        }
        this.getWithdrawalStatus()
        this.getMoneyData()
        this.getTableList()
        this.$confirm(`<div>
            <div>恭喜您，成功提现：${this.transformMoney(cash)} 元</div>
            <div>提现金额将在 15 分钟内打款至您微信钱包，请耐心等待，如遇超时未打款，您可联系调研工厂客服</div>
          </div>`, '提现', {
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
          confirmButtonText: '我知道了'
        })
      })
    },
    // 资金转移
    fundTransfer() {
      this.$confirm('注：充值金额将全部转移到提现金额，操作暂不可逆，请您确认是否转移？', '转移资金', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userInnerFundTransfer({amount: this.numMulti(this.customerCapital.balance, 1)}).then(res => {
          this.getMoneyData()
          this.getTableList()
          this.$message.success('资金转移成功')
        }).catch((err) => {console.log(err)})
      })
    },
    // 关闭二维码弹窗
    handleCodeClose() {
      this.codeDialogVisible = false
      this.handleAmountClose()
    },
    // 确认充值金额
    submitRecharge() {
      this.$refs.amountForm.validate((valid) => {
        if (!valid) return
        const params = {
          tradeType: 'JSAPI',
          fee: this.numMulti(this.amountForm.amount, 100),
          apiVersion: 3,
          companyId: 0
        }
        getQrCodeData(params).then(res => {
          this.codeUrl = `${getSurveyDomain()}/award/oauthInfo?returnUrl=${encodeURIComponent(
            `${getSurveyDomain()}/dygc-payment-system?prepayId=${res.prepayId}`
          )}`
          this.codeDialogVisible = true
        }).catch((err) => {
          console.log(err)
          this.handleAmountClose()
        })
      })
    },
    // 充值数值弹窗的关闭事件
    handleAmountClose() {
      this.amountDialogVisible = false
      this.amountForm.amount = null
    },
    // 点击微信充值按钮
    wxRecharge() {
      if(!this.customerUserInfo.weixinBinding) {
        this.$confirm('绑定微信后，方可操作充值', '温馨提示', {
          confirmButtonText: '去绑定',
          cancelButtonText: '暂不绑定',
          type: 'warning'
        }).then(() => {
          // 打开个人信息弹窗
          this.personalMsgShow = true
        })
      } else {
        this.amountDialogVisible = true
      }
    },
    // 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失
    numMulti(num1, num2) {
      let baseNum = 0
      try {
        baseNum += num1.toString().split(".")[1].length
      } catch (e) {console.log(e)}
      try {
        baseNum += num2.toString().split(".")[1].length
      } catch (e) {console.log(e)}
      return ((Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", ""))) / Math.pow(10, baseNum))
    },
    // 时间格式化
    timestampToTime(timestamp) {
      const date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const Y = date.getFullYear() + "-"
      const M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-"
      const D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " "
      const h = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":"
      const m = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":"
      const s = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds()
      const strDate = Y + M + D + " " + h + m + s
      return strDate
    },
    // 数值转换
    transformMoney(money) {
      const yuan = (money / 100).toFixed(2)
      return parseFloat(yuan).toLocaleString()
    },
    // 表格查询
    searchList() {
      this.page = {
        total: 0,
        currentPage: 1,
        pageSize: 10
      }
      this.getTableList()
    },
    // 重置表格
    reset() {
      this.tradeNo = ''
      this.createTime = []
      this.service = ''
      this.type = ''
      this.name = ''
      this.mobile = ''
      this.searchList()
    },
    sizeChange(val) {
      this.page.pageSize = val
      this.page.currentPage = 1
      this.getTableList()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.getTableList()
    },
    // 获取钱包信息
    getMoneyData() {
      getCustomerCaptial().then(res => {
        this.customerCapital = res
        this.YinLianCustomerCapital = res.companyUnipay
      }).catch((err) => {console.log(err)}).finally(() => {
        this.loading = false
      })
    },
    // 获取表格信息
    getTableList() {
      this.tableLoading = true
      let params = {
        length: this.page.pageSize,
        page: this.page.currentPage - 1,
        tradeNo: this.tradeNo,
        begin: this.createTime.length ? new Date(this.createTime[0]).getTime() : '',
        end: this.createTime.length ? new Date(this.createTime[1]).getTime() : '',
        service: this.service,
        type: this.type,
        name: this.name,
        mobile: this.mobile
      }
      getTransactionList(params).then(res => {
        this.page.total = res.total
        this.data = res.content
      }).catch((err) => {console.log(err)}).finally(() => {
        this.tableLoading = false
      })
    },
    // 获取搜索栏渠道
    getSearchChannel() {
      tradeRecordChanelApi().then(res => {
        this.channelOptions = res
      }).catch((err) => {console.log(err)})
    },
    // 获取搜索栏状态
    getSearchType() {
      tradeRecordTypeApi({channel: this.service}).then(res => {
        this.typeOptions = res
      }).catch((err) => {console.log(err)})
    },
    // 用户的提现检测
    getWithdrawalStatus() {
      withdrawalTest().then(res => {
        this.withdrawalData = res
      }).catch((err) => {console.log(err)})
      // 当日提现详细
      getWeChatCashOutInfo().then(res => {
        this.cashOutData = res
      }).catch((err) => {console.log(err)})
    }
  },
  created() {
    this.getMoneyData()
    this.getTableList()
    this.getSearchChannel()
    this.getSearchType()
    this.getWithdrawalStatus()
  }
}
</script>

<style scoped lang="scss">
.title {
  font-weight: 600;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 22px;
  position: relative;
  margin-bottom: 16px;
  &::before {
    content: '';
    display: block;
    width: 4px;
    height: 20px;
    background: #2775E8;
    position: absolute;
    left: -16px;
  }
  span {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
    font-weight: 500;
  }
}
.top-box {
  display: flex;
  justify-content: space-between;
  & > div {
    width: calc(50% - 8px);
    background: #FFFFFF;
    box-shadow: 0 1px 4px 0 #0000000f;
    border-radius: 4px;
    padding: 16px;
    box-sizing: border-box;
  }
  .amount {
    display: flex;
    & > div {
      flex: 1;
      padding-left: 25px;
      &:nth-child(1) {
        padding: 0;
      }
    }
    .line {
      width: 1px;
      height: 32px;
      flex: none;
      background: #D9DDE0;
      padding: 0;
      margin-top: 8px;
    }
  }
}
.list-box {
  height: calc(100% - 340px);
  margin-top: 16px;
  padding: 16px;
  background: #FFFFFF;
  box-shadow: 0 1px 4px 0 #0000000f;
  border-radius: 4px;
  .tableData {
    width: 100%;
    height: calc(100% - 70px);
    div {
      height: 100%;
    }
  }
}
::v-deep .el-range-editor {
  width: 100%;
}
::v-deep .el-form-item {
  margin-bottom: 0;
}
::v-deep .el-dialog__header {
  background: #F5F7FA;
  padding: 12px 16px;
}
::v-deep .el-dialog__body {
  padding: 24px 16px;
}
::v-deep .el-dialog__footer {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px;
}
.officialCode {
  width: 200px;
  height: 200px;
  display: block;
  margin: auto;
}
</style>
